module.exports = __webpack_public_path__ + "img/1600f.4daa9c89.png";